export default __webpack_public_path__ + "static/media/Rectangle 7.0d5d7078.png";